import React from 'react';

import classNames from 'classnames';

type BadgeProps = {
  theme?: 'success' | 'danger' | 'info' | 'warning';
  size?: 'micro' | 'small';
  children: React.ReactNode;
};

const Badge: React.FC<BadgeProps> = ({ theme, size, children }) => {
  return (
    <span
      className={classNames('badge', {
        [`badge--theme-${theme}`]: Boolean(theme),
        [`badge--size-${size}`]: Boolean(size),
      })}
    >
      {children}
    </span>
  );
};

export default Badge;
